import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//Hooks
import { useActionsLogin } from '@pages/home/hooks/useActionsLogin';
//Redux
import { RootState } from '@redux/rootReducer';
import { useAppDispatch, useAppSelector } from './redux';
import { clearSession, setInactive } from '@redux/session/session.slice';
//Utils
import localStorage from '@utils/LocalStorage';
import { LoginConstants, SESSION_INACTIVE_STATE } from '@constants/Session';

/**
 * Function
 */
export const useIdleTimer = (
    timeout: number
): {
    handleInactive: () => void;
} => {
    const timer = useRef<NodeJS.Timeout>();
    const location = useLocation();
    const navigation = useNavigate();
    const { handleLogoutRedirect } = useActionsLogin();
    const {
        session: { user, inactive },
    } = useAppSelector((state: RootState) => state);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (localStorage.get(LoginConstants.INACTIVE_SESSION) === 'true' || inactive) handleInactive();
    }, []);

    useEffect(() => {
        const resetTimer = (): void => {
            if (timer.current) clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                if (user?.homeAccountId) {
                    dispatch(setInactive(true));
                }
            }, timeout);
        };

        const handleStorage = (): void => {
            if (localStorage.get(LoginConstants.LOG_OUT) === 'true') {
                handleInactive();
            } else if (localStorage.get(LoginConstants.INACTIVE_SESSION) === 'true') {
                dispatch(setInactive(true));
            }
        };

        const events = ['mousemove', 'mousedown', 'keypress', 'scroll'];
        events.forEach(event => {
            window.addEventListener(event, resetTimer);
        });
        window.addEventListener('storage', handleStorage);
        resetTimer();

        return (): void => {
            events.forEach(event => {
                window.removeEventListener(event, resetTimer);
                window.removeEventListener('storage', handleStorage);
            });
            if (timer.current) clearTimeout(timer.current);
        };
    }, [location, navigation]);

    const handleInactive = (): void => {
        if (localStorage.get(LoginConstants.LOG_OUT) === 'false')
            localStorage.set(LoginConstants.LOG_OUT, SESSION_INACTIVE_STATE.SESSION_EXPIRED);
        user?.homeAccountId && dispatch(clearSession());
        handleLogoutRedirect();
    };

    return {
        handleInactive,
    };
};
